import React, { useState, useEffect } from "react";
import {
	Button,
	Form,
	Input,
	Select,
	Row,
	message,
	Col,
	Card,
	notification,
	Tabs,
	Upload,
	AutoComplete,
	Checkbox,
	Radio,
	DatePicker,
} from "antd";
import {
	MinusCircleOutlined,
	FileTextOutlined,
	PlusOutlined,
	InboxOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import userService from "../../services/user";
import equipmentService from "../../services/equipments";
import equipmentRequestService from "../../services/equipmentRequest";

import sapService from "../../services/sap";
import departmentService from "../../services/department";
import designationService from "../../services/designation";
import employeeService from "../../services/user";

import DefaultLayout from "../../components/layout/DefaultLayout";
import Header from "../../components/header";
import "./index.css";
import InventoryAssetComponent from "../../components/InventoryAsset";
import EquipmentCalculatComponent from "../../components/EquipmentCalculate";
import SapLocationComponent from "../../components/sapLocation";
import CostCenterComponent from "../../components/costCenter";
import DepartmentComponent from "../../components/department";
import SapTypeComponent from "../../components/sapType";
import SapPlantComponent from "../../components/sapPlant";
import CompanyComponent from "../../components/company";
import ParamComponent from "../../components/param";
import UserComponent from "../../components/user";
import DesignationComponent from "../../components/designation";

// FOR CUSTOM FIELDS
import customFieldService from "../../services/customField";
import commonCrud from "../../services/commonCrud";
import dayjs from "dayjs";

// import { Editor } from '@tinymce/tinymce-react';
const PostEquipmentRequest = () => {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const { currentUser } = useSelector((state) => state.user);
	const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
	const [editMode, setEditMode] = useState(false);
	const [editingEquipmentRequest, setEditingEquipmentRequest] = useState(null);
	const [isDraft, setIsDraft] = useState(null);
	const defaultLocationId = currentUser ? currentUser.location.id : null;
	const defaultDeparmentId = currentUser ? currentUser.department.id : null;
	const defaultDeparmentName = currentUser ? currentUser.department.name : null;
	const [departmentOptions, setDepartmentOptions] = React.useState([]);
	const [designationOptions, setDesignationOptions] = React.useState([]);
	const [employeeOptions, setEmployeeOptions] = React.useState([]);

	const compId =
		currentUser && currentUser.company ? currentUser.company.id : 1;
	// const defaultCompanyId = currentUser ? currentUser.department.id : null;

	const { TabPane } = Tabs;
	const [deletedAttachments, setDeletedAttachments] = useState([]);
	const [fileList, setFileList] = useState([]);
	const [selectedLocations, setSelectedLocations] = useState([]);
	const [selectedPlants, setSelectedPlants] = useState([]);
	const [emailOptions, setEmailOptions] = React.useState([]);

	const [editInvMode, setEditInvMode] = useState(false);

	const { id } = useParams();
	const navigate = useNavigate();

	const [companyId, setCompanyId] = useState(null);

	// FOR CUSTOM FIELDS
	const [customfields, setCustomFields] = useState([]);
	const [dynamicOptions, setDynamicOptions] = useState({});

	// Custom fields
	const getCustomFields = async (page = 1) => {  
		setLoading(true);
		await customFieldService.getcustomFields(7).then((response) => {

			const sorted = [...response].sort((a, b) => a.sort - b.sort);
			setCustomFields(sorted);
			setLoading(false);
		});

	};

	const fetchDynamicOptions = async (reference, dataType = "dynamic") => {
		if (!reference) return;

		// avoid re-fetch if already loaded
		if (dynamicOptions[reference]) return;

		try {
			console.log("fetchDynamicOptions for", reference);

			// handle lookups separately
			if (dataType === "lookups") {
			const response = await commonCrud.lookups(reference);
			if (response && Array.isArray(response)) {
				const options = response.map((val) => ({
				label: val,
				value: val,
				}));
				setDynamicOptions((prev) => ({ ...prev, [reference]: options }));
			}
			return;
			}

			// map of dynamic APIs
			const apiMap = {
			departments: commonCrud.departments,
			cost_centers: commonCrud.cost_centers,
			users: () => commonCrud.users("all"),
			projects: commonCrud.projects,
			sections: commonCrud.sections,
			categories: commonCrud.categories,
			designations: commonCrud.designations,
			locations: commonCrud.locations,
			equipments: commonCrud.equipments,
			forms: commonCrud.forms,
			subscribers: commonCrud.subscribers,
			approvers: () => commonCrud.approvers(1, 100),
			makes: () => commonCrud.makes(1, 100),
			companies: () => commonCrud.companies(1, 100),
			services: () => commonCrud.services(1, 100),
			};

			const fetchFn = apiMap[reference];
			if (!fetchFn) {
			console.warn(`No API found for reference: ${reference}`);
			return;
			}

			const response = await fetchFn();
			if (response && Array.isArray(response)) {
			const options = response.map((item) => ({
				label: item.name || item.title || item.cost_center || item.id,
				value: item.id,
			}));
			setDynamicOptions((prev) => ({ ...prev, [reference]: options }));
			}
		} catch (error) {
			console.error(`Failed to fetch ${reference} options:`, error);
		}
	};


	
	useEffect(() => {
	if (customfields.length > 0) {
		customfields.forEach((f) => {
		if ((f.data_type === "dynamic" || f.data_type === "lookups") && f.data_reference) {
			fetchDynamicOptions(f.data_reference, f.data_type);
		}
		});
	}
	}, [customfields]);

	const handleRequirementChange = (index, values) => {
		setSelectedCheckboxes((prev) => {
			const newCheckboxes = [...prev];
			newCheckboxes[index] = values;
			return newCheckboxes;
		});
	};

	useEffect(() => {
		const fetchData = async () => {
			try {
				if (id) {
					setLoading(true);
					setEditMode(true);

					const response = await sapService.getSapById(id);
					setLoading(false);

					if (response.type == "Modification") {
						setIsModification(true);
					}

					const locationIds = response.data.location.map((item) => item.id);
					const plantIds = response.data.plant.map((item) => item.id);
					setSelectedLocations(locationIds.map((item) => Number(item)));
					setSelectedPlants(plantIds.map((item) => Number(item)));

					setCompanyId(response?.company_id);

					console.log('response', response)

					// Initialize form values with proper handling for null/undefined
					const initialValues = {
						request_title: response.request_title || "",
						company_id: response.company?.id || "",
						for_email: response.for_email || "",
						for_department: response.for_department || "",
						for_designation: response.for_designation || "",
						for_employee: response.for_employee || "",
						location: locationIds.map((item) => Number(item)),
						type: response.type || "",
						sap_id: response.sap_id || "",
						roles_required: response.roles_required || "",
						tcode_required: response.tcode_required || "",
						plant: plantIds,
						business_justification: response.business_justification || "",
					};

					// Sales Distribution
					if (response.data.sales_distribution?.length) {
						initialValues.sales_distribution = response.data.sales_distribution;
					} else {
						initialValues.sales_distribution = [
							{
								sales_organization: [],
								distribution_channel: [],
								division: [],
								sales_office: [],
								sales_group: [],
								other_details: "",
							},
						];
					}

					// Material Management
					if (response.data.material_management?.length) {
						initialValues.material_management =
							response.data.material_management;
					} else {
						initialValues.material_management = [
							{
								purchasing_org: [],
								purchasing_group: [],
								storage_location: "",
								purchasing_document: "",
								movement_type: "",
								other_details: "",
							},
						];
					}

					// Plant Maintenance
					if (response.data.plant_maintenance?.length) {
						initialValues.plant_maintenance = response.data.plant_maintenance;
					} else {
						initialValues.plant_maintenance = [
							{
								planning_plant: [],
								maintenance_plant: [],
								work_centers: [],
								other_details: "",
							},
						];
					}

					// Financial Accounting & Costing
					if (response.data.financial_accounting_costing?.length) {
						initialValues.financial_accounting_costing =
							response.data.financial_accounting_costing;
					} else {
						initialValues.financial_accounting_costing = [
							{
								profile_center: [],
								cost_center: [],
								other_details: "",
							},
						];
					}

					// Production Planning
					if (response.data.production_planning?.length) {
						initialValues.production_planning =
							response.data.production_planning;
					} else {
						initialValues.production_planning = [
							{
								other_details: "",
							},
						];
					}

					// Human Resource
					if (response.data.human_resource?.length) {
						initialValues.human_resource = response.data.human_resource;
					} else {
						initialValues.human_resource = [
							{
								personnel_area: [],
								sub_area: [],
								cost_center: [],
								employee_group: [],
								employee_sub_group: [],
								other_details: "",
							},
						];
					}

					form.setFieldsValue(initialValues);

					// ✅ FOR CUSTOM FIELDS
					if (response.custom_fields && response.custom_fields.length > 0) {
						const customFieldValues = {};

						response.custom_fields.forEach((item) => {
							const fieldKey = `field_${item.custom_field.id}`;
							const label = item.custom_field.label?.toLowerCase() || "";
							const type = item.custom_field.type;

							if (
								label.includes("date") ||
								label.includes("dob") ||
								label.includes("day")
							) {
								const parsedDate = dayjs(item.value);
								customFieldValues[fieldKey] = parsedDate.isValid() ? parsedDate : null;
							} else if (type === "Multi") {
								customFieldValues[fieldKey] = item.value
									? item.value.split(",").map((v) => v.trim())
									: [];
							} else {
								customFieldValues[fieldKey] = item.value;
							}
						});

						form.setFieldsValue(customFieldValues);
					}

					setFileList(
						response.attachments.map((attachment) => ({
							key: attachment.id,
							uid: attachment.id,
							name: attachment.original_title,
							status: "done",
							url: attachment.filename,
						}))
					);
				}
			} catch (error) {
				if (error.response?.status === 500) {
					navigate("/sap-access-form");
				} else {
					console.log(error);
					notification.error({
						message: "Error fetching SAP Access Form",
						description: error.message,
					});
				}
			}
		};

		fetchData();
	}, [id, form, navigate]);

	useEffect(() => {
		const fetchDepartments = async () => {
			try {
				const response = await departmentService.getAllDepartments();
				setDepartmentOptions(
					response.map((dept) => ({
						label: dept.name, // Adjust based on your API response structure
						value: dept.name,
					}))
				);
			} catch (error) {
				console.error("Error fetching departments:", error);
				notification.error({
					message: "Failed to load departments",
					description: error.message,
				});
			}
		};

		fetchDepartments();
	}, []);
	useEffect(() => {
		const fetchDesignations = async () => {
			try {
				const response = await designationService.getAllDesignations();
				setDesignationOptions(
					response.map((designation) => ({
						label: designation.name,
						value: designation.name,
					}))
				);
			} catch (error) {
				console.error("Error fetching designations:", error);
			}
		};

		fetchDesignations();
	}, []);

	useEffect(() => {
		getCustomFields();
		const fetchEmployees = async () => {
			try {
				const apiResponse = await employeeService.getUsers(); // Renamed for clarity

				if (
					apiResponse &&
					apiResponse.success &&
					Array.isArray(apiResponse.data)
				) {
					setEmployeeOptions(
						apiResponse.data.map((employee) => ({
							label: employee.name + " / " + employee.employee_no,
							value: employee.name + " / " + employee.employee_no,
							title: employee.email,
						}))
					);
					setEmailOptions(
						apiResponse.data
							.filter((employee) => !!employee.email)
							.map((employee) => ({
								label: employee.email,
								value: employee.email,
								title: employee.name + " / " + employee.employee_no,
							}))
					);
				} else {
					console.error(
						"Error fetching employees: Invalid response format or unsuccessful request.",
						apiResponse
					);
					setEmployeeOptions([]); // Set to empty array on error or invalid format
					notification.error({
						message: "Failed to load employees",
						description:
							apiResponse?.message ||
							"Received invalid data format from server.",
					});
				}
			} catch (error) {
				console.error("Error fetching employees:", error);
				notification.error({
					message: "Failed to load employees",
					description: error.message || "An unexpected error occurred.",
				});
				setEmployeeOptions([]); // Ensure options are cleared on network/API errors
			}
		};

		fetchEmployees();
	}, []);

	// SAP ID CONDITION
	const [isModification, setIsModification] = useState(false);

	const handleSapTypeChange = (value) => {
		setIsModification(value === "Modification" || value === "Transfer of ID");

		if (value === "Modification" || value === "Transfer of ID") {
			form.setFields([
				{
					name: "sap_current_id",
					errors: [],
				},
			]);
		} else {
			form.setFieldsValue({ sap_current_id: undefined });
		}
	};
	// SAP ID CONDITION

	// For Image
	const props = {
		onRemove: (file) => {
			const index = fileList.indexOf(file);
			const newFileList = fileList.slice();
			newFileList.splice(index, 1);
			handleRemoveAttachment(file);
			setFileList(newFileList);
		},
		beforeUpload: (file) => {
			setFileList((prevFileList) => {
				return prevFileList ? [...prevFileList, file] : [file];
			});
			return false;
		},
		fileList,
	};
	const handleRemoveAttachment = (file) => {
		setFileList((prevFileList) =>
			prevFileList.filter((f) => f.uid !== file.uid)
		);
		console.log("file ", file);

		if (file.url) {
			setDeletedAttachments((prevDeleted) => [...prevDeleted, file.key]);
			console.log("send file.key  ", file.key);
		}
	};

	// For Location
	const locationOptions = [
		{ id: 1, name: "Head Office" },
		{ id: 2, name: "Karachi Plant" },
		{ id: 3, name: "Pezu Plant" },
		{ id: 4, name: "Area Office" },
		{ id: 5, name: "Islamabad" },
		{ id: 6, name: "Lahore" },
		{ id: 7, name: "Peshawar" },
		{ id: 8, name: "Multan" },
		{ id: 9, name: "Faisalabad" },
		{ id: 10, name: "Quetta" },
	];
	const handleLocationChange = (values) => {
		// console.log('locationOnchange');
		// console.log(values);
		// console.log('locationOnchange');
		setSelectedLocations(values);
	};

	// For Plant

	const plantOptions = [
		{ id: 1, name: "PIBT" },
		{ id: 2, name: "QICT" },
		{ id: 3, name: "LCHO" },
		{ id: 4, name: "LCKP" },
		{ id: 5, name: "LCPZ" },
		{ id: 6, name: "LKPT" },
		{ id: 7, name: "PKGP" },
		{ id: 8, name: "PGPZ" },
	];
	const handlePlantChange = (values) => {
		// const valupdplant = values.map((id) => ({
		//   id: parseInt(id, 10), // Convert string to integer
		//   name: plantOptions.find((option) => option.id === parseInt(id, 10))?.name,
		// }));
		setSelectedPlants(values);
	};

	// For Validation OF Sections

	const onFinish = async (values) => {
		const {
			sales_distribution,
			material_management,
			plant_maintenance,
			financial_accounting_costing,
			production_planning,
			human_resource,
		} = values;
		if (
			(!sales_distribution || sales_distribution.length === 0) &&
			(!material_management || material_management.length === 0) &&
			(!plant_maintenance || plant_maintenance.length === 0) &&
			(!financial_accounting_costing ||
				financial_accounting_costing.length === 0) &&
			(!production_planning || production_planning.length === 0) &&
			(!human_resource || human_resource.length === 0)
		) {
			message.error(
				"Please fill out at least one tab (SD, MM,, PM, FICO, PP, or HR)"
			);
			return;
		}

		try {
			values.save_as_draft = String(isDraft);

			//  HANDLE CUSTOM FIELDS
			const customFields = {};
			Object.keys(values).forEach((key) => {
				if (key.startsWith("field_")) {
					const fieldId = key.replace("field_", "");
					customFields[fieldId] = Array.isArray(values[key])
						? values[key].join(",")
						: values[key];
				}
			});
			if (Object.keys(customFields).length > 0) {
				values.custom_fields = customFields;
			}
			//  END CUSTOM FIELDS

			const formattedData = {
				...values,
				location: selectedLocations.map((id) => ({
					id,
					name: locationOptions.find((option) => option.id === id)?.name,
				})),
				plant: selectedPlants.map((id) => ({
					id,
					name: plantOptions.find((option) => option.id === id)?.name,
				})),
				sap_id: values.type === "New" ? "1" : values.sap_id,
				save_as_draft: values.save_as_draft,
				attachments: fileList
					? fileList.filter((file) => !file.url).map((file) => file)
					: [],
				deleted_attachments: deletedAttachments,
			};

			if (editMode) {
				const response = await sapService.updateSapForm(id, formattedData);

				if (response.success) {
					setEditMode(false);
					setEditingEquipmentRequest(null);
					notification.success({
						message: "Sap Access Form Updated",
						description: response.message,
					});
					navigate("/sap-access-form");
				}
			} else {
				const response = await sapService.postSapRequest(formattedData);

				if (response.success) {
					form.resetFields();
					notification.success({
						message: "Sap Access Form Added",
						description: response.message,
					});
					navigate("/sap-access-form");
				}
			}
		} catch (error) {
			console.log(error);
			notification.error({
				message: "Sap Access Form Operation Failed",
				description: error.response.data.message,
			});
		}
	};

	const getCurrentUser = async () => {
		setLoading(true);
		try {
			const response = await userService.getCurrentUser(currentUser.user_id);
			//console.log(response);
			form.setFieldsValue({
				name: response.name,
				email: response.email,
				designation_id: response.designation.name,
				employee_no: response.employee_no,
				employee_type: response.employee_type,
				extension: response.extension,
				phone_number: response.phone_number,
				profile_location: response.location.name,
				role_id: response.roles.map((role) => role.id),
				// department_id: response.department.name,
				section_id: response.section.name,
			});
		} catch (error) {
		} finally {
			setLoading(false);
		}
	};

	const validateCheckboxGroup = (_, values) => {
		if (values && values.length > 0) {
			return Promise.resolve();
		}
		return Promise.reject(new Error("Please select at least one requirement."));
	};

	useEffect(() => {
		getCurrentUser();
	}, []);

	return (
		<DefaultLayout>
			<Row gutter={[24, 24]}>
				<Col span={24}>
					<Header icon={<FileTextOutlined />} title='SAP Access Form' />
				</Col>
			</Row>
			<Card>
				<Form
					autoComplete='off'
					onFinish={onFinish}
					form={form}
					layout='vertical'
					scrollToFirstError
					className='mt-20'
					initialValues={{
						for_department: String(defaultDeparmentName), // your default department id
					}}
				>
					<div spinning={loading}>
						<Card
							size='small'
							className='mb-10'
							title='To be filled by Requestor'
						>
							<Row gutter={[12, 12]}>
								<Col lg={8} md={8} sm={24} xs={24}>
									<Form.Item
										name='request_title'
										label='Request Title'
										rules={[{ required: true, message: "Type Request Title" }]}
									>
										<Input
											placeholder='Type Request Title'
											size='large'
											allowClear
										/>
									</Form.Item>
								</Col>
								<Col lg={8} md={8} sm={24} xs={24}>
									<Form.Item
										name='company_id'
										label='Company'
										rules={[
											{
												required: true,
												message: "Please select a Company",
											},
										]}
									>
										<CompanyComponent all={true} />
									</Form.Item>
								</Col>

								<Col lg={8} md={8} sm={24} xs={24}>
									<Form.Item
										name='location'
										label='Location'
										// rules={[
										//   { required: true, message: 'Please select a location' },
										// ]}
									>
										<SapLocationComponent
											value={selectedLocations}
											onChange={handleLocationChange}
										/>
									</Form.Item>
								</Col>
							</Row>

							{/* New Dropdowns and Email Textbox */}
							<Row gutter={[12, 12]}>
								<Col lg={6} md={12} sm={24} xs={24}>
									<Form.Item
										name='for_department'
										label='For Department'
										rules={[
											{ required: true, message: "Please select a Department" },
										]}
									>
										<AutoComplete
											style={{ width: "100%" }}
											options={departmentOptions}
											placeholder='Select Department'
											size='large'
											filterOption={(inputValue, option) =>
												option.value
													.toUpperCase()
													.indexOf(inputValue.toUpperCase()) !== -1
											}
											allowClear
										/>
									</Form.Item>
								</Col>
								<Col lg={6} md={12} sm={24} xs={24}>
									<Form.Item
										name='for_designation'
										label='For Designation'
										rules={[
											{
												required: true,
												message: "Please select a Designation",
											},
										]}
									>
										<AutoComplete
											style={{ width: "100%" }}
											options={designationOptions}
											placeholder='Select Designation'
											size='large'
											filterOption={(inputValue, option) =>
												option.value
													.toUpperCase()
													.indexOf(inputValue.toUpperCase()) !== -1
											}
											allowClear
										/>
									</Form.Item>
								</Col>
								<Col lg={6} md={12} sm={24} xs={24}>
									<Form.Item
										name='for_employee'
										label='For Employee'
										rules={[
											{ required: true, message: "Please select an Employee" },
										]}
									>
										<AutoComplete
											style={{ width: "100%" }}
											options={employeeOptions}
											placeholder='Select Employee'
											size='large'
											filterOption={(inputValue, option) =>
												option.value
													.toUpperCase()
													.indexOf(inputValue.toUpperCase()) !== -1
											}
											allowClear
										/>
									</Form.Item>
								</Col>
								<Col lg={6} md={12} sm={24} xs={24}>
									<Form.Item
										name='for_email'
										label='For Email'
										rules={[
											{ required: true, message: "Please enter an Email" },
											{ type: "email", message: "Please enter a valid Email" },
										]}
									>
										<AutoComplete
											style={{ width: "100%" }}
											options={emailOptions}
											placeholder='Select or enter Email'
											size='large'
											filterOption={(inputValue, option) =>
												option.value
													.toUpperCase()
													.indexOf(inputValue.toUpperCase()) !== -1
											}
											allowClear
										/>
									</Form.Item>
								</Col>
							</Row>

							<Row gutter={[12, 12]}>
								<Col lg={12} md={12} sm={24} xs={24}>
									<Form.Item
										name='type'
										label='Type'
										rules={[
											{ required: true, message: "Please select a Type" },
										]}
									>
										<SapTypeComponent onChange={handleSapTypeChange} />
									</Form.Item>
								</Col>

								{isModification && (
									<Col lg={12} md={12} sm={24} xs={24}>
										<Form.Item
											name='sap_id'
											label='ID:'
											rules={[
												...(isModification
													? [
															{
																required: true,
																message: "Required Transfer of ID:",
															},
													  ]
													: []),
											]}
										>
											<Input
												placeholder='ID:'
												size='large'
												disabled={!isModification}
											/>
										</Form.Item>
									</Col>
								)}
							</Row>
						</Card>

						<Card
							size='small'
							className='mb-10'
							title='Required ID & Access on Module(s)'
						>
							<Row gutter={[12, 12]}>
								<Col lg={8} md={8} sm={24} xs={24}>
									<Form.Item
										name='roles_required'
										label='Roles Required'
										// rules={[{ required: true, message: 'Type Roles Required:' }]}
									>
										<Input
											placeholder='Type Roles Required:'
											size='large'
											allowClear
										/>
									</Form.Item>
								</Col>
								<Col lg={8} md={8} sm={24} xs={24}>
									<Form.Item
										name='tcode_required'
										label='T.Code Required'
										// rules={[{ required: true, message: 'Type T.Code Required:' }]}
									>
										<Input
											placeholder='Type T.Code Required:'
											size='large'
											allowClear
										/>
									</Form.Item>
								</Col>
								<Col lg={8} md={8} sm={24} xs={24}>
									<Form.Item
										name='plant'
										label='Plant'
										// rules={[
										//   { required: true, message: 'Please select a Plant' },
										// ]}
									>
										<SapPlantComponent
											value={selectedPlants}
											onChange={handlePlantChange}
										/>
										;
									</Form.Item>
								</Col>
							</Row>

							<Row gutter={[12, 12]}>
								<Col lg={24} md={24} sm={24} xs={24}>
									<Form.Item
										name='business_justification'
										label='Business Justification'
										// rules={[{ required: true, message: 'Type Business Justification' }]}
									>
										<Input.TextArea
											rows={4}
											size='large'
											placeholder={`Enter Business Justification`}
										/>
									</Form.Item>
								</Col>
							</Row>
						</Card>

						{/* Tabs for distinct sections */}
						{/* Tabs for distinct sections */}
						<Tabs defaultActiveKey='1' className='mb-10 ml-10 mr-10'>
							{/* Sales and Distribution (SD) Section */}
							<TabPane tab='Sales and Distribution (SD)' key='1'>
								<Card size='small'>
									<Row gutter={[12, 12]}>
										<Col lg={8} sm={24}>
											{/*  <Form.Item
                      name={['sales_distribution',0,'sales_organization']}
                      label="Sales Organization"
                      rules={[]}
                    >
                      <Input placeholder="Enter Sales Organization" />
                    </Form.Item>*/}
											<Form.Item
												name={["sales_distribution", 0, "sales_organization"]}
												label='Sales Organization'
												rules={[]}
											>
												<ParamComponent
													type={"saf_sd_sales_organization"}
													all={true}
													compId={compId}
												/>
											</Form.Item>
										</Col>
										<Col lg={8} sm={24}>
											<Form.Item
												name={["sales_distribution", 0, "distribution_channel"]}
												label='Distribution Channel'
											>
												<ParamComponent
													type={"saf_sd_distribution_channel"}
													all={true}
													compId={compId}
												/>
											</Form.Item>
										</Col>
										<Col lg={8} sm={24}>
											<Form.Item
												name={["sales_distribution", 0, "division"]}
												label='Division'
												rules={[]}
											>
												<ParamComponent
													type={"saf_sd_division"}
													all={true}
													compId={compId}
												/>
											</Form.Item>
										</Col>
										<Col lg={12} sm={24}>
											<Form.Item
												name={["sales_distribution", 0, "sales_office"]}
												label='Sales Office'
												rules={[]}
											>
												<ParamComponent
													type={"saf_sd_sales_office"}
													all={true}
													compId={compId}
												/>
											</Form.Item>
										</Col>
										<Col lg={12} sm={24}>
											<Form.Item
												name={["sales_distribution", 0, "sales_group"]}
												label='Sales Group'
												rules={[]}
											>
												<ParamComponent
													type={"saf_sd_sales_group"}
													all={true}
													compId={compId}
												/>
											</Form.Item>
										</Col>
										<Col span={24}>
											<Form.Item
												name={["sales_distribution", 0, "other_details"]}
												label='Other Details'
												rules={[]}
											>
												<Input.TextArea
													rows={4}
													placeholder='Enter Other Details'
												/>
											</Form.Item>
										</Col>
									</Row>
								</Card>
							</TabPane>

							{/* Material Management (MM) Section */}
							<TabPane tab='Material Management (MM)' key='2'>
								<Card size='small'>
									<Row gutter={[12, 12]}>
										<Col lg={12} sm={24}>
											<Form.Item
												name={["material_management", 0, "purchasing_org"]}
												label='Purchasing Org'
												rules={[]}
											>
												<ParamComponent
													type={"saf_mm_purchasing_org"}
													all={true}
													compId={compId}
												/>
											</Form.Item>
										</Col>
										<Col lg={12} sm={24}>
											<Form.Item
												name={["material_management", 0, "purchasing_group"]}
												label='Purchasing Group'
												rules={[]}
											>
												<ParamComponent
													type={"saf_mm_purchasing_group"}
													all={true}
													compId={compId}
												/>
											</Form.Item>
										</Col>
										<Col lg={12} sm={24}>
											<Form.Item
												name={["material_management", 0, "storage_location"]}
												label='Storage Location'
												rules={[]}
											>
												<Input placeholder='Storage Location' size='large' />

												{/*<ParamComponent type={'saf_mm_storage_location'} all={true}  compId={compId}  />*/}
											</Form.Item>
										</Col>
										<Col lg={12} sm={24}>
											<Form.Item
												name={["material_management", 0, "purchasing_document"]}
												label='Purchasing Document'
												rules={[]}
											>
												<Input placeholder='Purchasing Document' size='large' />

												{/*<ParamComponent type={'saf_mm_purchasing_document'} all={true}  compId={compId}  />*/}
											</Form.Item>
										</Col>
										<Col lg={12} sm={24}>
											<Form.Item
												name={["material_management", 0, "movement_type"]}
												label='Movement Type'
												rules={[]}
											>
												<Input placeholder='Movement Type' size='large' />

												{/*<ParamComponent type={'saf_mm_movement_type'} all={true}  compId={compId}  />*/}
											</Form.Item>
										</Col>
										<Col span={24}>
											<Form.Item
												name={["material_management", 0, "other_details"]}
												label='Other Details'
												rules={[]}
											>
												<Input.TextArea
													rows={4}
													placeholder='Enter Other Details'
												/>
											</Form.Item>
										</Col>
									</Row>
								</Card>
							</TabPane>

							{/* Plant Maintenance (PM) Section */}
							<TabPane tab='Plant Maintenance (PM)' key='3'>
								<Card size='small'>
									<Row gutter={[12, 12]}>
										<Col span={8}>
											<Form.Item
												name={["plant_maintenance", 0, "planning_plant"]}
												label='Planning Plant'
												rules={[]}
											>
												<ParamComponent
													type={"saf_pm_planning_plant"}
													all={true}
													compId={compId}
												/>
											</Form.Item>
										</Col>
										<Col span={8}>
											<Form.Item
												name={["plant_maintenance", 0, "maintenance_plant"]}
												label='Maintenance Plant'
												rules={[]}
											>
												<ParamComponent
													type={"saf_pm_maintenance_plant"}
													all={true}
													compId={compId}
												/>
											</Form.Item>
										</Col>
										<Col span={8}>
											<Form.Item
												name={["plant_maintenance", 0, "work_centers"]}
												label='Work Centers'
												rules={[]}
											>
												<ParamComponent
													type={"saf_pm_work_center"}
													all={true}
													compId={compId}
												/>
											</Form.Item>
										</Col>
										<Col span={24}>
											<Form.Item
												name={["plant_maintenance", 0, "other_details"]}
												label='Other Details'
												rules={[]}
											>
												<Input.TextArea
													rows={4}
													placeholder='Enter Other Details'
												/>
											</Form.Item>
										</Col>
									</Row>
								</Card>
							</TabPane>

							{/* Financial Accounting & Costing (FICO) Section */}
							<TabPane tab='Financial Accounting & Costing (FICO)' key='4'>
								<Card size='small'>
									<Row gutter={[12, 12]}>
										<Col span={12}>
											<Form.Item
												name={[
													"financial_accounting_costing",
													0,
													"profile_center",
												]}
												label='Profile Center'
												rules={[]}
											>
												<ParamComponent
													type={"saf_fico_profit_center"}
													all={true}
													compId={compId}
												/>
											</Form.Item>
										</Col>
										<Col span={12}>
											<Form.Item
												name={[
													"financial_accounting_costing",
													0,
													"cost_center",
												]}
												label='Cost Center'
												rules={[]}
											>
												<ParamComponent
													type={"saf_fico_cost_center"}
													all={true}
													compId={compId}
												/>
											</Form.Item>
										</Col>
										<Col span={24}>
											<Form.Item
												name={[
													"financial_accounting_costing",
													0,
													"other_details",
												]}
												label='Other Details'
												rules={[]}
											>
												<Input.TextArea
													rows={4}
													placeholder='Enter Other Details'
												/>
											</Form.Item>
										</Col>
									</Row>
								</Card>
							</TabPane>

							{/* Production Planning (PP) Section */}
							<TabPane tab='Production Planning (PP)' key='5'>
								<Card size='small'>
									<Form.Item
										name={["production_planning", 0, "other_details"]}
										label='Other Details'
										rules={[]}
									>
										<Input.TextArea
											rows={4}
											placeholder='Enter Other Details'
										/>
									</Form.Item>
								</Card>
							</TabPane>

							{/* Human Resource (HR) Section */}
							<TabPane tab='Human Resource (HR)' key='6'>
								<Card size='small'>
									<Row gutter={[12, 12]}>
										<Col lg={8} sm={24}>
											<Form.Item
												name={["human_resource", 0, "personnel_area"]}
												label='Personnel Area'
												rules={[]}
											>
												<ParamComponent
													type={"saf_hr_personnel_area"}
													all={true}
													compId={compId}
												/>
											</Form.Item>
										</Col>
										<Col lg={8} sm={24}>
											<Form.Item
												name={["human_resource", 0, "sub_area"]}
												label='Sub Area'
												rules={[]}
											>
												<ParamComponent
													type={"saf_hr_sub_area"}
													all={true}
													compId={compId}
												/>
											</Form.Item>
										</Col>
										<Col lg={8} sm={24}>
											<Form.Item
												name={["human_resource", 0, "cost_center"]}
												label='Cost Center'
												rules={[]}
											>
												<ParamComponent
													type={"saf_hr_cost_center"}
													all={true}
													compId={compId}
												/>
											</Form.Item>
										</Col>
										<Col lg={12} sm={24}>
											<Form.Item
												name={["human_resource", 0, "employee_group"]}
												label='Employee Group'
												rules={[]}
											>
												<ParamComponent
													type={"saf_hr_employee_group"}
													all={true}
													compId={compId}
												/>
											</Form.Item>
										</Col>
										<Col lg={12} sm={24}>
											<Form.Item
												name={["human_resource", 0, "employee_sub_group"]}
												label='Employee Sub Group'
												rules={[]}
											>
												<ParamComponent
													type={"saf_hr_employee_sup_group"}
													all={true}
													compId={compId}
												/>
											</Form.Item>
										</Col>
										<Col span={24}>
											<Form.Item
												name={["human_resource", 0, "other_details"]}
												label='Other Details'
												rules={[]}
											>
												<Input.TextArea
													rows={4}
													placeholder='Enter Other Details'
												/>
											</Form.Item>
										</Col>
									</Row>
								</Card>
							</TabPane>
						</Tabs>

						{/* ATTACHMENT */}
						<Card size='small' className='mb-10' title='Attachment(s)'>
							<Row gutter={[12, 12]}>
								<Col span={24} className='mb-40'>
									<Upload.Dragger
										multiple
										{...props}
										onRemove={(file) => handleRemoveAttachment(file)}
									>
										<p className='ant-upload-drag-icon'>
											<InboxOutlined />
										</p>
										<p className='ant-upload-text'>
											Click or drag files to this area to upload
										</p>
									</Upload.Dragger>
								</Col>
							</Row>
						</Card>
						{/* ATTACHMENT */}

						{/* Custom Fields Section */}
						{customfields && customfields.length > 0 && (
							<Card title="System Generated Fields">
							<Row gutter={[24, 24]}>
								{customfields
								.sort((a, b) => a.sort - b.sort)
								.map((field) => {
									const colSize =
									field.col_desktop === "Small"
										? 6
										: field.col_desktop === "Medium"
										? 12
										: 24;

									const rules = [];
									if (field.required) {
									rules.push({
										required: true,
										message: `${field.label} is required`,
									});
									}
									if (field.data_type === "number") {
									rules.push({
										pattern: /^[0-9]*$/,
										message: "Only numbers allowed",
									});
									}

									return (
									<Col
										key={field.id}
										lg={colSize}
										md={colSize}
										sm={24}
										xs={24}
									>
										<Form.Item
											label={field.label}
											name={`field_${field.id}`}
											rules={rules}
											initialValue={
												field.type === "Date"
												? field.default_value
													? dayjs(field.default_value)
													: dayjs()
												: field.type === "Datetime"
												? field.default_value
													? dayjs(field.default_value)
													: dayjs()
												: field.type === "Checkbox"
												? field.default_value
													? field.default_value.split(",")
													: []
												: field.type === "Multi"
												? field.default_value
													? field.default_value.split(",")
													: []
												: field.default_value || ""
											}
											>
											{field.type === "Input" ? (
												<Input
												size="large"
												disabled={!!field.disabled}
												placeholder={`Enter ${field.label}`}
												/>
											) : field.type === "Textarea" ? (
												<Input.TextArea
												rows={4}
												disabled={!!field.disabled}
												placeholder={`Enter ${field.label}`}
												/>
											) : field.type === "Select" || field.type === "Multi" ? (
												<Select
													showSearch
													allowClear
													size="large"
													placeholder="Please select"
													mode={field.type === "Multi" ? "multiple" : undefined}
													disabled={!!field.disabled}
													onFocus={() =>
														(field.data_type === "dynamic" || field.data_type === "lookups") &&
														fetchDynamicOptions(field.data_reference, field.data_type)
													}
													>
													{field.data_type === "static" && field.data_values
														? field.data_values.split("|").map((val) => (
															<Select.Option key={val.trim()} value={val.trim()}>
															{val.trim()}
															</Select.Option>
														))
														: (field.data_type === "dynamic" || field.data_type === "lookups") &&
														dynamicOptions[field.data_reference] &&
														dynamicOptions[field.data_reference].map((opt) => (
															<Select.Option key={opt.label} value={opt.label}>
															{opt.label}
															</Select.Option>
														))}
												</Select>

											) : field.type === "Number" ? (
												<Input
												type="number"
												size="large"
												disabled={!!field.disabled}
												placeholder={`Enter ${field.label}`}
												/>
											) : field.type === "Checkbox" ? (
												<Checkbox.Group
												disabled={!!field.disabled}
												options={
													field.data_values
													? field.data_values.split("|").map((val) => ({
														label: val.trim(),
														value: val.trim(),
														}))
													: field.default_value
													? field.default_value.split(",").map((val) => ({
														label: val.trim(),
														value: val.trim(),
														}))
													: []
												}
												/>
											) : field.type === "Radio" ? (
												<Radio.Group
												disabled={!!field.disabled}
												options={
													field.data_values
													? field.data_values.split(",").map((val) => ({
														label: val,
														value: val,
														}))
													: []
												}
												/>
											) : field.type === "Date" ? (
												<DatePicker style={{ width: "100%" }} disabled={!!field.disabled} />
											) : field.type === "Datetime" ? (
												<DatePicker
												style={{ width: "100%" }}
												showTime
												disabled={!!field.disabled}
												/>
											) : (
												<Input
												size="large"
												disabled={!!field.disabled}
												placeholder={`Enter ${field.label}`}
												/>
											)}
										</Form.Item>

									</Col>
									);
								})}
							</Row>
							</Card>
						)}

						<Row gutter={[12, 12]} className='mt-40'>
							<Col span={24} className='text-right'>
								<div
									style={{ display: "flex", justifyContent: "space-between" }}
									className='mt-24'
								>
									<Button
										type='primary'
										block
										disabled={loading}
										loading={loading}
										className='btn-blue mr-20'
										onClick={() => {
											setIsDraft(false);
											form.submit();
										}}
									>
										Save & Publish
									</Button>
									<Button
										disabled={loading}
										loading={loading}
										type='primary'
										onClick={() => {
											setIsDraft(true);
											form.submit();
										}}
									>
										Save Draft
									</Button>
								</div>
							</Col>
						</Row>
					</div>
				</Form>
			</Card>
		</DefaultLayout>
	);
};

export default PostEquipmentRequest;
